// extracted by mini-css-extract-plugin
module.exports = {"cont":"_93444fe79c--cont--39BoU","name":"_93444fe79c--name--kDRm-","textarea":"_93444fe79c--textarea--3-1XB","textarea-error":"_93444fe79c--textarea-error--2Ldj4"};